/* assets/custom-options.js
   Custom option sets + rules + line item properties + bundled addon support
   (Wood Stain, Seat Type, Fabric Selection, Panel Options, Leg Style, Nail Head Options, + more taggable sets)
*/

(function () {
  var WOOD_TRIGGER = 'Wood Type';
  // Frontend display order for native Shopify "Wood Type" variant values.
  // Values are matched case-insensitively against the option value text.
  // Keep this list in your preferred order.
  var WOOD_TYPE_DISPLAY_ORDER = [
    'Oak',
    'Brown Maple',
    'Cherry',
    'Hickory',
    'Maple',
    'Quarter Sawn White Oak',
    'Rustic Cherry',
    'Rustic Hickory',
    'Rustic Quarter Sawn White Oak',
    'Walnut',
    'Elm'
  ];
  var SEAT_TRIGGER = 'Seat Type';
  var CUSHION_TRIGGER = 'Cushion Upholstery';

  var SEAT_TAG = 'co:seat-type';
  var SEAT_SET_KEY = 'seat_type';
  var FABRIC_SET_KEY = 'fabric_selection';
  var EARLY_AMERICAN_FABRIC_TAG = 'co:early_american_fabric_options';
  var EARLY_AMERICAN_FABRIC_SET_KEY = 'early_american_fabric_selection';
  var EARLY_AMERICAN_FABRIC_LIST_KEY = 'early_american_fabric_selection';

  // Taggable list option sets (co:<option_name>)
  var PANEL_TAG = 'co:panel_options';
  var PANEL_SET_KEY = 'panel_options';

  var LEG_TAG = 'co:leg_style';
  var LEG_SET_KEY = 'leg_style';

  var NAIL_TAG = 'co:nail_head_options';
  var NAIL_SET_KEY = 'nail_head_options';

  // NEW taggable sets
  var CAMBRIA_TOP_TAG = 'co:cambria_top_options';
  var CAMBRIA_TOP_KEY = 'cambria_top_options';

  var CARVING_STYLE_TAG = 'co:carving_style';
  var CARVING_STYLE_KEY = 'carving_style';

  var FRONT_CARVING_TAG = 'co:front_carving';
  var FRONT_CARVING_KEY = 'front_carving';

  var TOP_CARVING_TAG = 'co:top_carving';
  var TOP_CARVING_KEY = 'top_carving';

  var GLASS_OPTIONS_TAG = 'co:glass_options';
  var GLASS_OPTIONS_KEY = 'glass_options';

  var PRESSBACK_OPTIONS_TAG = 'co:pressback_options';
  var PRESSBACK_OPTIONS_KEY = 'pressback_options';

  var FOOTREST_OPTIONS_TAG = 'co:footrest_options';
  var FOOTREST_OPTIONS_KEY = 'footrest_options';

  var TABLE_TOP_CUTOUT_TAG = 'co:table_top_cutout';
  var TABLE_TOP_CUTOUT_KEY = 'table_top_cutout';

  var PAINT_COLORS_TAG = 'co:paint_colors';
  var PAINT_COLORS_KEY = 'paint_colors';

  var BAINBRIDGE_TAG = 'co:bainbridge';

  var NO_STAINS_TAG = 'co:no_stains';

  var PAINT_COLORS_BROWN_MAPLE_KEY = 'paint_colors_brown_maple';
  var PAINT_COLORS_OAK_KEY  = 'paint_colors_oak';

  var PAINT_COLOR_VARIANTS = [PAINT_COLORS_BROWN_MAPLE_KEY, PAINT_COLORS_OAK_KEY];

  // Poly Colors

  // --- Poly Color taggable option sets ---
  // Tag format:  co:<set_key>
  // Example:     co:poly_colors_11_colors

  var POLY_COLORS_29_COLORS_TAG = 'co:poly_colors_29_colors';
  var POLY_COLORS_29_COLORS_KEY = 'poly_colors_29_colors';

  var POLY_COLORS_11_COLORS_TAG = 'co:poly_colors_11_colors';
  var POLY_COLORS_11_COLORS_KEY = 'poly_colors_11_colors';

  var POLY_COLORS_SLIDE_OUT_CUP_HOLDER_TAG = 'co:poly_colors_slide_out_cup_holder';
  var POLY_COLORS_SLIDE_OUT_CUP_HOLDER_KEY = 'poly_colors_slide_out_cup_holder';

  var POLY_COLORS_TUG_HILL_ADIRONDACK_BALCONY_CHAIR_TAG = 'co:poly_colors_tug_hill_adirondack_balcony_chair';
  var POLY_COLORS_TUG_HILL_ADIRONDACK_BALCONY_CHAIR_KEY = 'poly_colors_tug_hill_adirondack_balcony_chair';

  var POLY_COLORS_TUG_HILL_BALCONY_TABLE_TAG = 'co:poly_colors_tug_hill_balcony_table';
  var POLY_COLORS_TUG_HILL_BALCONY_TABLE_KEY = 'poly_colors_tug_hill_balcony_table';

  var POLY_COLORS_11_TABLES_TAG = 'co:poly_colors_11_tables';
  var POLY_COLORS_11_TABLES_KEY = 'poly_colors_11_tables';

  var POLY_COLORS_TUG_HILL_FOLDING_ADIRONDACK_CHAIR_TAG = 'co:poly_colors_tug_hill_folding_adirondack_chair';
  var POLY_COLORS_TUG_HILL_FOLDING_ADIRONDACK_CHAIR_KEY = 'poly_colors_tug_hill_folding_adirondack_chair';

  var POLY_COLORS_17_TAG = 'co:poly_colors_17_colors';
  var POLY_COLORS_17_KEY = 'poly_colors_17_colors';

  var POLY_COLORS_STATIONARY_CUP_HOLDER_TAG = 'co:poly_colors_stationary_cup_holder';
  var POLY_COLORS_STATIONARY_CUP_HOLDER_KEY = 'poly_colors_stationary_cup_holder';

  var POLY_FURNITURE_COLORS_LEGACY_TRADITIONAL_MODERN_AND_DESIGNER_TAG = 'co:poly_colors_legacy_traditional_modern_and_designer';
  var POLY_FURNITURE_COLORS_LEGACY_TRADITIONAL_MODERN_AND_DESIGNER_KEY = 'poly_colors_legacy_traditional_modern_and_designer';

  var SPECIALTY_COLOR_TAG = 'co:specialty_color';
  var SPECIALTY_COLOR_KEY = 'specialty_color';



  // Central list so adding more later is painless
  var TAGGABLE_SETS = [
    { key: EARLY_AMERICAN_FABRIC_SET_KEY, tag: EARLY_AMERICAN_FABRIC_TAG, required: true, file_list_key: EARLY_AMERICAN_FABRIC_LIST_KEY },
    { key: PANEL_SET_KEY, tag: PANEL_TAG, required: true },
    { key: LEG_SET_KEY, tag: LEG_TAG, required: true },
    { key: NAIL_SET_KEY, tag: NAIL_TAG, required: true },

    { key: CAMBRIA_TOP_KEY, tag: CAMBRIA_TOP_TAG, required: false },
    { key: PAINT_COLORS_KEY, tag: PAINT_COLORS_TAG, required: false, dynamic: true },
    { key: CARVING_STYLE_KEY, tag: CARVING_STYLE_TAG, required: false },
    { key: FRONT_CARVING_KEY, tag: FRONT_CARVING_TAG, required: false },
    { key: TOP_CARVING_KEY, tag: TOP_CARVING_TAG, required: false },
    { key: GLASS_OPTIONS_KEY, tag: GLASS_OPTIONS_TAG, required: false },
    { key: PRESSBACK_OPTIONS_KEY, tag: PRESSBACK_OPTIONS_TAG, required: false },
    { key: FOOTREST_OPTIONS_KEY, tag: FOOTREST_OPTIONS_TAG, required: true },
    { key: TABLE_TOP_CUTOUT_KEY, tag: TABLE_TOP_CUTOUT_TAG, required: true },
    { key: POLY_COLORS_11_COLORS_KEY, tag: POLY_COLORS_11_COLORS_TAG, required: true },
    { key: POLY_COLORS_11_TABLES_KEY, tag: POLY_COLORS_11_TABLES_TAG, required: true },
    { key: POLY_COLORS_17_KEY, tag: POLY_COLORS_17_TAG, required: true },
    { key: POLY_COLORS_29_COLORS_KEY, tag: POLY_COLORS_29_COLORS_TAG, required: true },
    { key: POLY_COLORS_TUG_HILL_FOLDING_ADIRONDACK_CHAIR_KEY, tag: POLY_COLORS_TUG_HILL_FOLDING_ADIRONDACK_CHAIR_TAG, required: true },
    { key: POLY_COLORS_TUG_HILL_ADIRONDACK_BALCONY_CHAIR_KEY, tag: POLY_COLORS_TUG_HILL_ADIRONDACK_BALCONY_CHAIR_TAG, required: true },
    { key: POLY_COLORS_TUG_HILL_BALCONY_TABLE_KEY, tag: POLY_COLORS_TUG_HILL_BALCONY_TABLE_TAG, required: true },
    { key: POLY_COLORS_STATIONARY_CUP_HOLDER_KEY, tag: POLY_COLORS_STATIONARY_CUP_HOLDER_TAG, required: true },
    { key: POLY_COLORS_SLIDE_OUT_CUP_HOLDER_KEY, tag: POLY_COLORS_SLIDE_OUT_CUP_HOLDER_TAG, required: true },
    { key: POLY_FURNITURE_COLORS_LEGACY_TRADITIONAL_MODERN_AND_DESIGNER_KEY, tag: POLY_FURNITURE_COLORS_LEGACY_TRADITIONAL_MODERN_AND_DESIGNER_TAG, required: true },
    { key: SPECIALTY_COLOR_KEY, tag: SPECIALTY_COLOR_TAG, required: true }
  ];

  // Stable display order (add more keys later)
  // NOTE: include base keys (wood_stain) — ordering function treats wood_stain_* as wood_stain
  var ORDERED_SET_KEYS = [
    'seat_type',
    'fabric_selection',
    'early_american_fabric_selection',

    // taggable sets after fabrics (tweak order here if you want)
    'panel_options',
    'leg_style',
    'nail_head_options',
    'cambria_top_options',
    'carving_style',
    'front_carving',
    'top_carving',
    'glass_options',
    'pressback_options',
    'footrest_options',
    'table_top_cutout',
    'paint_colors',
    'paint_colors_oak',
    'paint_colors_brown_maple',
    'specialty_color',
    'wood_stain',

  ];

  // ---------- Helpers ----------
  function toArray(nl) { return Array.prototype.slice.call(nl || []); }

  // Coerce Liquid/JSON “drops” into plain strings
  function asString(v) {
    if (v === null || v === undefined) return '';
    if (typeof v === 'string') return v;
    if (typeof v === 'number') return String(v);
    if (typeof v === 'boolean') return v ? 'true' : 'false';
    if (typeof v === 'object') {
      if (typeof v.value === 'string' || typeof v.value === 'number') return String(v.value);
      if (typeof v.handle === 'string') return v.handle;
      try { return JSON.stringify(v); } catch (e) { return ''; }
    }
    return String(v);
  }

  function normalizeKey(label) {
    return String(label || '')
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9\s_-]/g, '')
      .trim()
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_');
  }

  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }

  function titleCaseWords(str) {
    return String(str || '')
      .split(/[\s_-]+/)
      .filter(Boolean)
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
      .join(' ');
  }

  function getWoodLabelForStainSetKey(setKey) {
    // expects: wood_stain_oak, wood_stain_brown_maple, etc.
    var m = String(setKey || '').match(/^wood_stain(?:_+(.+))?$/i);
    if (!m) return '';
    var tail = m[1] ? String(m[1]).trim() : '';
    if (!tail) return '';
    return titleCaseWords(tail);
  }

  //  unique property name per set (fixes 2-wood-stain collision on variant change)
  function getPropertyNameForSet(setKey, title) {
    if (String(setKey || '').indexOf('wood_stain') === 0) {
      var woodLabel = getWoodLabelForStainSetKey(setKey);
      return woodLabel ? ('Wood Stain: ' + woodLabel) : 'Wood Stain';
    }

    // NEW: unify paint variants under one property label
    if (setKey === 'paint_colors' || String(setKey).indexOf('paint_colors_') === 0) {
      return 'Paint Colors';
    }

    if (setKey === EARLY_AMERICAN_FABRIC_SET_KEY) {
      return 'Early American Fabric Selection';
    }

    return title || setKey;
  }


  // Normalize addon variant id from numeric, gid, object, or JSON-like payloads.
  function parseVariantId(raw) {
    if (raw === null || raw === undefined) return null;

    if (typeof raw === 'number') {
      if (!isFinite(raw) || raw <= 0) return null;
      return Math.floor(raw);
    }

    if (typeof raw === 'object') {
      if (raw.id !== undefined && raw.id !== null) return parseVariantId(raw.id);
      if (raw.value !== undefined && raw.value !== null) return parseVariantId(raw.value);
      if (raw.admin_graphql_api_id) return parseVariantId(raw.admin_graphql_api_id);
      try { raw = JSON.stringify(raw); } catch (e) { return null; }
    }

    var s = String(raw || '').trim();
    if (!s) return null;

    if (/^\d+$/.test(s)) return Number(s);

    var gidMatch = s.match(/ProductVariant\/(\d+)/i);
    if (gidMatch && gidMatch[1]) return Number(gidMatch[1]);

    var jsonId = s.match(/"id"\s*:\s*"?(\d+)"?/i);
    if (jsonId && jsonId[1]) return Number(jsonId[1]);

    var longDigits = s.match(/(\d{6,})/);
    if (longDigits && longDigits[1]) return Number(longDigits[1]);

    var trailing = s.match(/(\d+)\s*$/);
    if (trailing && trailing[1]) return Number(trailing[1]);

    return null;
  }

  function parseAddonPriceCents(raw) {
    if (raw === null || raw === undefined || raw === '') return 0;

    if (typeof raw === 'number') {
      if (!isFinite(raw) || raw < 0) return 0;
      return Math.round(raw);
    }

    if (typeof raw === 'object') {
      if (raw.amount !== undefined && raw.amount !== null) return parseAddonPriceCents(raw.amount);
      if (raw.value !== undefined && raw.value !== null) return parseAddonPriceCents(raw.value);
      try { raw = JSON.stringify(raw); } catch (e) { return 0; }
    }

    var s = String(raw || '').trim();
    if (!s) return 0;

    if (/^\d+$/.test(s)) {
      var intOnly = Number(s);
      return (isFinite(intOnly) && intOnly >= 0) ? intOnly : 0;
    }

    var cleaned = s.replace(/[^0-9.,-]/g, '');
    if (!cleaned) return 0;

    // Handle "1,234.56" and "1234,56" shapes.
    var normalized = cleaned;
    var hasDot = normalized.indexOf('.') !== -1;
    var hasComma = normalized.indexOf(',') !== -1;
    if (hasDot && hasComma) normalized = normalized.replace(/,/g, '');
    else if (!hasDot && hasComma) normalized = normalized.replace(/,/g, '.');
    else normalized = normalized.replace(/,/g, '');

    var asNumber = Number(normalized);
    if (!isFinite(asNumber) || asNumber < 0) return 0;

    if (normalized.indexOf('.') !== -1) return Math.round(asNumber * 100);
    return Math.round(asNumber);
  }

  function parseJSONFromScript(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function safeParseActions(text) {
    if (!text || typeof text !== 'string') return [];
    try {
      var parsed = JSON.parse(text);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  // Case-insensitive check if product has a Shopify option name
  function hasShopifyOption(instance, optionName) {
    var names = (instance.cfg && instance.cfg.optionNames) ? instance.cfg.optionNames : [];
    return names.map(function (n) { return String(n || '').trim().toLowerCase(); })
      .indexOf(String(optionName || '').trim().toLowerCase()) !== -1;
  }

  function getStainKeysFromTags(instance) {
    var tags = (instance.cfg.productTags || []).map(function (t) { return String(t || '').trim(); });
    if (!tags.length) return [];

    var keys = [];
    var seen = {};

    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || '').trim();
      var m = t.match(/^co:stain=(.+)$/i);
      if (!m || !m[1]) continue;

      var k = normalizeKey(m[1]);
      if (!k || seen[k]) continue;

      seen[k] = true;
      keys.push(k);
    }

    return keys;
  }

  // Generic case-insensitive tag check
  function hasTag(instance, tag) {
    var tags = (instance.cfg.productTags || []).map(function (t) { return String(t || '').trim().toLowerCase(); });
    return tags.indexOf(String(tag || '').trim().toLowerCase()) !== -1;
  }

  function updateCartBadges(count) {
    var txt = String(count);

    document.querySelectorAll('.cart-count-badge, .CartCount, #CartCountCavas').forEach(function (el) {
      el.textContent = txt;
      el.setAttribute('data-count', txt);
    });

    document.querySelectorAll('a[aria-label^="Cart"]').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart ' + txt);
    });
  }

// Replace a section by id (best effort: outerHTML if wrapper exists, else innerHTML)
function applySectionHtml(sectionId, html) {
  if (!sectionId || !html) return;

  var target = document.getElementById(sectionId);
  if (!target) return;

  var tmp = document.createElement('div');
  tmp.innerHTML = html;

  // If the returned HTML contains a wrapper with the same id, replace the whole node
  var incomingWrapper = tmp.querySelector('#' + CSS.escape(sectionId));
  if (incomingWrapper) {
    target.replaceWith(incomingWrapper);
  } else {
    // Otherwise just replace contents
    target.innerHTML = html;
  }
}

function applySectionsObject(sectionsObj) {
  if (!sectionsObj || typeof sectionsObj !== 'object') return;

  Object.keys(sectionsObj).forEach(function (key) {
    applySectionHtml(key, sectionsObj[key]);
  });
}

function clearSet(instance, setKey) {
  clearSlot(instance, setKey);
  clearPropertyBySetKey(instance.propsHostEl, setKey);
  instance.selectedCustom[setKey] = null;
  instance.required[setKey] = false;
}

function clearPaintColorVariants(instance) {
  PAINT_COLOR_VARIANTS.forEach(function(k){
    clearSet(instance, k);
  });
  // also clear the visible slot container if you’re using PAINT_COLORS_KEY as a slot
  clearSlot(instance, PAINT_COLORS_KEY);
}

function bainbridgeKeyFor(setKey) {
  // wood_stain_oak -> wood_stain_oak_bainbridge
  // wood_stain_brown_maple -> wood_stain_brown_maple_bainbridge
  if (!setKey || String(setKey).indexOf('wood_stain_') !== 0) return setKey;
  if (/_bainbridge$/i.test(setKey)) return setKey; // already bainbridge
  return setKey + '_bainbridge';
}

function clearAllWoodStains(instance) {
  Object.keys(instance.idx.setsByKey || {}).forEach(function (k) {
    if (String(k).indexOf('wood_stain') === 0) {
      clearSlot(instance, k);
      clearPropertyBySetKey(instance.propsHostEl, k);
      instance.selectedCustom[k] = null;
      instance.required[k] = false;
    }
  });
  instance._lastWoodKeysSig = '';
}




  // ---------- Special rule: Carving Style controls Front/Top Carving ----------
  function isNoCarvingSelected(instance) {
    var sel = instance.selectedCustom && instance.selectedCustom[CARVING_STYLE_KEY];
    if (!sel) return false;

    // prefer key, fallback to label
    var k = asString(sel.key).trim();
    var l = asString(sel.label).trim();

    k = k ? normalizeKey(k) : '';
    l = l ? normalizeKey(l) : '';

    return (k === 'no_carving' || l === 'no_carving');
  }

  function applyCarvingRules(instance) {
    // If the product doesn’t even use carving style, nothing to do
    if (!hasTag(instance, CARVING_STYLE_TAG)) return;

    var noCarving = isNoCarvingSelected(instance);

    // When "No Carving" => hide/remove dependent sets
    if (noCarving) {
      // Only clear if those sets exist on this product
      if (hasTag(instance, FRONT_CARVING_TAG)) clearSet(instance, FRONT_CARVING_KEY);
      if (hasTag(instance, TOP_CARVING_TAG)) clearSet(instance, TOP_CARVING_KEY);
      return;
    }

    // Otherwise, bring them back if tagged on product
    if (hasTag(instance, FRONT_CARVING_TAG)) {
      var frontSet = instance.idx.setsByKey[FRONT_CARVING_KEY];
      if (frontSet) renderOptionSet(instance, frontSet, null, false, { forceRerender: true });
    } else {
      clearSet(instance, FRONT_CARVING_KEY);
    }

    if (hasTag(instance, TOP_CARVING_TAG)) {
      var topSet = instance.idx.setsByKey[TOP_CARVING_KEY];
      if (topSet) renderOptionSet(instance, topSet, null, false, { forceRerender: true });
    } else {
      clearSet(instance, TOP_CARVING_KEY);
    }
  }


  function getAddonFromActiveControl(instance, setKey) {
    var slot = getSlot(instance, setKey);
    if (!slot) return null;

    var scope = slot.querySelector('[data-custom-set="' + setKey + '"]') || slot;
    var active = null;

    active = scope.querySelector('input[type="radio"]:checked');

    if (!active) {
      var selectEl = scope.querySelector('select');
      if (selectEl && selectEl.options && selectEl.selectedIndex >= 0) {
        var opt = selectEl.options[selectEl.selectedIndex];
        if (opt && opt.value) active = opt;
      }
    }

    if (!active || !active.dataset) return null;
    return {
      addon_variant_id: active.dataset.addonVariantId || '',
      addon_variant_price: active.dataset.addonVariantPrice || ''
    };
  }

  // Collect addon selections from selected options and hidden property metadata.
  function getAddonSelections(instance) {
    var out = [];

    var keys = {};
    Object.keys(instance.selectedCustom || {}).forEach(function (k) { keys[k] = true; });

    toArray(instance.propsHostEl ? instance.propsHostEl.querySelectorAll('input[data-custom-prop-for]') : []).forEach(function (inp) {
      var k = inp && inp.getAttribute ? inp.getAttribute('data-custom-prop-for') : '';
      if (k) keys[k] = true;
    });

    Object.keys(keys).forEach(function (setKey) {
      var sel = instance.selectedCustom ? instance.selectedCustom[setKey] : null;
      var propInp = instance.propsHostEl ? instance.propsHostEl.querySelector('input[data-custom-prop-for="' + setKey + '"]') : null;

      // Fallback: rebuild from property label when selectedCustom was dropped by a rerender.
      if (!sel) {
        var setObjFallback = instance.idx && instance.idx.setsByKey ? instance.idx.setsByKey[setKey] : null;
        var selectedLabel = propInp && propInp.value ? String(propInp.value).trim() : '';
        if (setObjFallback && selectedLabel && Array.isArray(setObjFallback.values)) {
          sel = setObjFallback.values.find(function (v) {
            return asString(v && v.label).trim() === selectedLabel;
          }) || null;
        }
      }

      var addonRaw = '';
      if (propInp && propInp.dataset && propInp.dataset.addonVariantId) {
        addonRaw = String(propInp.dataset.addonVariantId).trim();
      }
      if (!addonRaw && sel && sel.addon_variant_id !== undefined && sel.addon_variant_id !== null) {
        addonRaw = String(sel.addon_variant_id).trim();
      }
      if (!addonRaw) {
        var fromUi = getAddonFromActiveControl(instance, setKey);
        if (fromUi && fromUi.addon_variant_id) addonRaw = String(fromUi.addon_variant_id).trim();
      }

      var parsed = parseVariantId(addonRaw);
      if (!parsed) return;

      var addonPrice = 0;
      if (propInp && propInp.dataset && propInp.dataset.addonVariantPrice !== undefined && propInp.dataset.addonVariantPrice !== null && propInp.dataset.addonVariantPrice !== '') {
        addonPrice = parseAddonPriceCents(propInp.dataset.addonVariantPrice);
      }
      if (!addonPrice && sel && sel.addon_variant_price !== undefined && sel.addon_variant_price !== null && sel.addon_variant_price !== '') {
        addonPrice = parseAddonPriceCents(sel.addon_variant_price);
      }
      if (!addonPrice) {
        var fromUiPrice = getAddonFromActiveControl(instance, setKey);
        if (fromUiPrice && fromUiPrice.addon_variant_price !== undefined && fromUiPrice.addon_variant_price !== null && fromUiPrice.addon_variant_price !== '') {
          addonPrice = parseAddonPriceCents(fromUiPrice.addon_variant_price);
        }
      }

      var setObj = instance.idx && instance.idx.setsByKey ? instance.idx.setsByKey[setKey] : null;
      var title = setObj ? (setObj.title || setKey) : setKey;
      var propName = getPropertyNameForSet(setKey, title);

      out.push({
        setKey: setKey,
        label: propName,
        addon_variant_id: String(parsed),
        addon_variant_price: addonPrice
      });
    });

    var seen = {};
    out = out.filter(function (a) {
      if (!a.addon_variant_id || seen[a.addon_variant_id]) return false;
      seen[a.addon_variant_id] = true;
      return true;
    });

    return out;
  }

  function showAddToCartError(instance, msg) {
    var cartContainer = document.querySelector('cart-container');
    if (cartContainer && cartContainer.showError) cartContainer.showError(msg);
    else alert(msg);
  }

  function setAddToCartButtonBusy(button, isBusy) {
    if (!button) return;

    if (isBusy) {
      button.classList.add('loading');
      button.style.pointerEvents = 'none';
      return;
    }

    button.classList.remove('loading');
    button.style.pointerEvents = '';
    if (document.activeElement === button && typeof button.blur === 'function') {
      button.blur();
    }
  }

  function openMiniCartDrawer() {
    var mini = document.getElementById('desktop_cart');
    if (mini) mini.classList.add('active');
    document.querySelectorAll('.sidebar-overlay').forEach(function (overlay) {
      overlay.classList.add('act');
    });
  }

  // ✅ Refresh cart badge + offcanvas after AJAX add (matches your DOM)
  async function refreshCartUI() {
    var cart = null;

    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (res.ok) {
        cart = await res.json();
        updateCartBadges(Number(cart && cart.item_count ? cart.item_count : 0));
        window.dispatchEvent(new CustomEvent('co.cart.updated', { detail: cart }));
        window.dispatchEvent(new CustomEvent('kt.cart.updated', { detail: cart }));
      }
    } catch (e) {}

    try {
      var mini = document.getElementById('cart-info');
      if (mini) {
        var htmlRes = await fetch('/cart?view=json', { headers: { 'Accept': 'text/html' } });
        if (htmlRes.ok) {
          mini.innerHTML = await htmlRes.text();

          window.dispatchEvent(new CustomEvent('co.cart.drawer.updated', {
            detail: { source: 'custom-options.refreshCartUI' }
          }));
        }
      }
    } catch (e) {}
  }



  //  cache full variant payload for addon variants (price + availability)
  const _coVariantDataCache = new Map();

  async function getVariantData(variantId) {
    const idNum = parseVariantId(variantId);
    if (!idNum) return null;

    const id = String(idNum);
    if (_coVariantDataCache.has(id)) return _coVariantDataCache.get(id);

    try {
      const res = await fetch(`/variants/${id}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) {
        _coVariantDataCache.set(id, null);
        return null;
      }
      const data = await res.json();
      _coVariantDataCache.set(id, data || null);
      return data || null;
    } catch (e) {
      _coVariantDataCache.set(id, null);
      return null;
    }
  }

  // ---------- Step 3: Fabric lists loaded from theme JSON asset ----------
  // Expect Liquid to output:
  // <script type="application/json" data-custom-fabrics>{{ 'custom-fabrics.json' | asset_url | json }}</script>
  var _coFabricCache = null;
  var _coFabricPromise = null;

  async function loadFabricLists() {
    if (_coFabricCache) return _coFabricCache;
    if (_coFabricPromise) return _coFabricPromise;

    _coFabricPromise = (async function () {
      var urlEl = document.querySelector('[data-custom-fabrics]');
      if (!urlEl) return null;

      var url = null;
      try { url = JSON.parse(urlEl.textContent); } catch (e) { url = null; }
      if (!url) return null;

      var res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return null;

      var data = await res.json();
      _coFabricCache = data || null;
      return _coFabricCache;
    })();

    return _coFabricPromise;
  }

  function buildTextSet(setKey, title, items, displayType) {
    return {
      key: setKey,
      title: title,
      display_type: displayType || 'radio',
      values: (items || []).map(function (label) {
        var lab = asString(label).trim();
        return { label: lab, key: normalizeKey(lab), image: '', sort_order: 999999, addon_variant_id: '' };
      })
    };
  }

  async function renderFileBackedTaggableSet(instance, def) {
    var fabricsData = await loadFabricLists();
    var setObj = instance.idx.setsByKey[def.key] || null;
    var title = setObj
      ? asString(setObj.title || def.key).trim()
      : titleCaseWords(def.key);
    var listKey = asString(def.file_list_key || def.key).trim();
    var list = (fabricsData && listKey && Array.isArray(fabricsData[listKey]))
      ? fabricsData[listKey]
      : [];

    if (!list.length) {
      clearSlot(instance, def.key);
      clearPropertyBySetKey(instance.propsHostEl, def.key);
      instance.selectedCustom[def.key] = null;
      instance.required[def.key] = false;
      return;
    }

    renderOptionSet(
      instance,
      buildTextSet(def.key, title, list, 'list'),
      null,
      !!def.required,
      { forceRerender: false }
    );
  }

  // ---------- Fake bundle pricing (display-only) ----------
  // Keep a single in-flight write. Native variant changes use a trailing sync after the theme swaps its own price HTML.
  function clearScheduledBundledPrice(instance) {
    if (!instance) return;
    if (instance._coPriceTimer) {
      clearTimeout(instance._coPriceTimer);
      instance._coPriceTimer = null;
    }
    if (instance._coPriceFrame) {
      cancelAnimationFrame(instance._coPriceFrame);
      instance._coPriceFrame = null;
    }
  }

  function scheduleBundledPrice(instance, opts) {
    opts = opts || {};
    clearScheduledBundledPrice(instance);

    if (instance._coThemePriceTimer) {
      clearTimeout(instance._coThemePriceTimer);
      instance._coThemePriceTimer = null;
    }
    instance._coAwaitingThemePrice = false;

    var delay = Number(opts.delay || 0);
    var run = function () {
      instance._coPriceTimer = null;
      instance._coPriceFrame = null;
      renderBundledPrice(instance);
    };

    if (delay > 0) {
      instance._coPriceTimer = setTimeout(run, delay);
      return;
    }

    if (typeof requestAnimationFrame === 'function') {
      instance._coPriceFrame = requestAnimationFrame(run);
      return;
    }

    instance._coPriceTimer = setTimeout(run, 0);
  }

  function scheduleBundledPriceAfterTheme(instance) {
    if (!instance) return;

    clearScheduledBundledPrice(instance);
    if (instance._coThemePriceTimer) clearTimeout(instance._coThemePriceTimer);

    instance._coAwaitingThemePrice = true;
    instance._coThemePriceTimer = setTimeout(function () {
      instance._coThemePriceTimer = null;
      instance._coAwaitingThemePrice = false;
      scheduleBundledPrice(instance);
    }, 350);
  }

  //  UPDATED: safe + supports numeric or gid, and doesn't throw on 404/network
  async function getVariantPriceCents(variantId, fallbackCents) {
    var fb = parseAddonPriceCents(fallbackCents);
    if (isFinite(fb) && fb > 0) return fb;

    const v = await getVariantData(variantId);
    if (v && v.price !== undefined && v.price !== null) {
      var fromVariant = Number(v.price);
      if (isFinite(fromVariant) && fromVariant >= 0) return fromVariant;
    }

    return 0;
  }

  function getCurrentVariantFromForm(formEl) {
    const id = Number(formEl.querySelector('[name="id"]')?.value || 0);
    if (!id) return null;

    try {
      const variants = JSON.parse(formEl.dataset.variants || '[]');
      if (Array.isArray(variants) && variants.length) {
        var fromData = variants.find(function (v) { return Number(v.id) === id; }) || null;
        if (fromData) return fromData;
      }
    } catch (e) {}

    var jsonEl =
      formEl.querySelector('product-variant-swatch script[type="application/json"]') ||
      formEl.querySelector('product-variant-dropdown script[data-variants-json]') ||
      formEl.querySelector('product-variant-dropdown script[type="application/json"]');

    if (jsonEl) {
      try {
        const variantsFromOptionUI = JSON.parse(jsonEl.textContent || '[]');
        if (Array.isArray(variantsFromOptionUI)) {
          return variantsFromOptionUI.find(function (v) { return Number(v.id) === id; }) || null;
        }
      } catch (e) {}
    }

    return null;
  }

  function getSectionTokenFromForm(formEl) {
    if (!formEl) return '';

    var formId = String(formEl.id || '').trim();
    if (formId) {
      var patterns = [
        /^product-form-sticky-(.+)$/i,
        /^product-form-(.+)$/i
      ];
      for (var i = 0; i < patterns.length; i++) {
        var m = formId.match(patterns[i]);
        if (m && m[1]) return String(m[1]).trim();
      }
    }

    var dataSection = formEl.getAttribute ? String(formEl.getAttribute('data-section') || '').trim() : '';
    if (dataSection) return dataSection;

    return '';
  }

  function getPriceContainerForForm(formEl) {
    var token = getSectionTokenFromForm(formEl);
    if (!token) return null;
    return document.getElementById('ProductPrice-' + token);
  }

  function getPriceContainersForForm(formEl) {
    var out = [];
    var seen = {};
    function add(el) {
      if (!el) return;
      if (seen[el]) return;
      seen[el] = true;
      out.push(el);
    }

    var token = getSectionTokenFromForm(formEl);
    if (token) {
      add(document.getElementById('ProductPrice-' + token));
      add(document.getElementById('ProductPriceStick-' + token));
    }

    var main = getPriceContainerForForm(formEl);
    add(main);

    if (!out.length && formEl) {
      var scope =
        formEl.closest('[id^="shopify-section-"]') ||
        formEl.closest('.nov-product__single-info') ||
        formEl.closest('.info_content') ||
        formEl.closest('.product-single') ||
        formEl.closest('.product-template__container');

      if (scope) {
        toArray(scope.querySelectorAll('[id^="ProductPrice-"], [id^="ProductPriceStick-"]')).forEach(add);
        if (!out.length) {
          toArray(scope.querySelectorAll('.product-single__price, .product-single__price-sticky')).forEach(add);
        }
      }
    }

    if (!out.length && formEl) {
      var parent = formEl.parentElement;
      while (parent && parent !== document.body && !out.length) {
        toArray(parent.querySelectorAll('[id^="ProductPrice-"], [id^="ProductPriceStick-"], .product-single__price, .product-single__price-sticky')).forEach(add);
        parent = parent.parentElement;
      }
    }

    return out;
  }

  function bindPriceObserver(instance) {
    if (!instance || instance._coPriceObserverBound) return;

    var targets = getPriceContainersForForm(instance.formEl);
    if (!targets.length || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (instance._coWritingPrice) return;
      if (!getAddonSelections(instance).length) return;

      if (instance._coThemePriceTimer) {
        clearTimeout(instance._coThemePriceTimer);
        instance._coThemePriceTimer = null;
      }
      instance._coAwaitingThemePrice = false;
      scheduleBundledPrice(instance);
    });

    targets.forEach(function (target) {
      observer.observe(target, { childList: true, subtree: true, characterData: true });
    });
    instance._coPriceObserver = observer;
    instance._coPriceObserverBound = true;
  }

  function renderPriceContainerHtml(priceWrapEl, finalCents, compareCents) {
    if (!priceWrapEl) return;

    var format = function (cents) {
      return (window.Shopify && window.Shopify.formatMoney)
        ? window.Shopify.formatMoney(cents)
        : String(cents);
    };

    var finalVal = Number(finalCents || 0);
    var compareVal = Number(compareCents || 0);
    var sale = compareVal > finalVal;

    if (sale) {
      var pct = Math.round(((compareVal - finalVal) / compareVal) * 100);
      priceWrapEl.innerHTML =
        '<span class="product-price__price product-price__sale product-price__sale--single">' +
          '<span itemprop="price" content="' + (finalVal / 100) + '">' + format(finalVal) + '</span>' +
        '</span>' +
        '<s>' + format(compareVal) + '</s>' +
        '<span class="product-price__badge">-' + pct + '%</span>';
    } else {
      priceWrapEl.innerHTML =
        '<span class="product-price__price">' +
          '<span itemprop="price" content="' + (finalVal / 100) + '">' + format(finalVal) + '</span>' +
        '</span>';
    }
  }

  function renderPriceWrapsForForm(formEl, finalCents, compareCents) {
    var wraps = getPriceContainersForForm(formEl);
    wraps.forEach(function (priceWrap) {
      renderPriceContainerHtml(priceWrap, finalCents, compareCents);
    });
    return wraps.length;
  }

  function getSyntheticCompareCents(priceCents) {
    var base = Number(priceCents || 0);
    if (!isFinite(base) || base <= 0) return 0;
    return Math.round((base * 100) / 67);
  }

  function removeBundlePriceNote(formEl) {
    var n1 = formEl.querySelector('.co-bundle-price-note');
    if (n1) n1.remove();

    getPriceContainersForForm(formEl).forEach(function (priceWrap) {
      if (!priceWrap || !priceWrap.parentElement) return;
      var n2 = priceWrap.parentElement.querySelector('.co-bundle-price-note');
      if (n2) n2.remove();
    });
  }

  function renderPriceLikeTheme(formEl, variant) {
    if (!variant) return;

    const comparePrice = formEl.querySelector('.product-price-compare');
    const finalPrice = formEl.querySelector('.product-price-final');
    const compareBadge = formEl.querySelector('.product-sale-badge');
    const soldOutBadge = formEl.querySelector('.product-sold-out-badge');
    const basePrice = Number(variant.price || 0);
    const syntheticCompare = getSyntheticCompareCents(basePrice);

    const format = (cents) =>
      (window.Shopify && window.Shopify.formatMoney) ? window.Shopify.formatMoney(cents) : String(cents);

    if (finalPrice) {
      if (syntheticCompare > basePrice) {
        if (comparePrice) {
          comparePrice.textContent = format(syntheticCompare);
          comparePrice.removeAttribute('hidden');
        }
        finalPrice.innerHTML = format(basePrice);
        finalPrice.classList.add('product-price-final-sale');

        if (compareBadge) {
          compareBadge.removeAttribute('hidden');
          const discountType = compareBadge.dataset.discountType;
          if (discountType === 'percentage') {
            const savingsPct = 100 - Math.round((basePrice / syntheticCompare) * 100);
            compareBadge.textContent = `${(window.theme && window.theme.locales && window.theme.locales.product && window.theme.locales.product.save) || 'Save'} ${savingsPct}%`;
          } else {
            const savings = format(syntheticCompare - basePrice);
            compareBadge.textContent = `${(window.theme && window.theme.locales && window.theme.locales.product && window.theme.locales.product.save) || 'Save'} ${savings}`;
          }
        }
      } else {
        if (comparePrice) {
          comparePrice.textContent = '';
          comparePrice.setAttribute('hidden', 'hidden');
        }
        finalPrice.innerHTML = format(basePrice);
        finalPrice.classList.remove('product-price-final-sale');
        if (compareBadge) {
          compareBadge.textContent = '';
          compareBadge.setAttribute('hidden', 'hidden');
        }
      }

      if (soldOutBadge) {
        if (variant.available) soldOutBadge.setAttribute('hidden', 'hidden');
        else soldOutBadge.removeAttribute('hidden');
      }

      removeBundlePriceNote(formEl);
      return;
    }

    renderPriceWrapsForForm(formEl, basePrice, syntheticCompare > basePrice ? syntheticCompare : 0);
    removeBundlePriceNote(formEl);
  }

  //  supports multiple addon variants from ANY option set (Seat Type, Carving Style, etc.)
  async function renderBundledPrice(instance) {
    const formEl = instance.formEl;
    const renderSeq = (instance._coPriceRenderSeq || 0) + 1;
    instance._coPriceRenderSeq = renderSeq;

    const variant = instance._selectedVariant || getCurrentVariantFromForm(formEl) || (instance.cfg ? instance.cfg.selectedVariant : null);
    if (!variant) return;

    const addons = getAddonSelections(instance);
    if (instance.cfg && instance.cfg.debug) {
      console.log('[CO][price] variant=', variant && variant.id, 'base=', Number(variant.price || 0), 'addons=', addons);
    }

    if (!addons.length) {
      renderPriceLikeTheme(formEl, variant);
      return;
    }

    let addonTotal = 0;
    for (let i = 0; i < addons.length; i++) {
      addonTotal += await getVariantPriceCents(addons[i].addon_variant_id, addons[i].addon_variant_price);
    }

    if (instance._coPriceRenderSeq !== renderSeq) return;

    const basePrice = Number(variant.price || 0);

    const combinedFinal = basePrice + addonTotal;
    const combinedCompareRaw = getSyntheticCompareCents(combinedFinal);
    const combinedCompare = (combinedCompareRaw > combinedFinal) ? combinedCompareRaw : 0;

    const comparePrice = formEl.querySelector('.product-price-compare');
    const finalPrice = formEl.querySelector('.product-price-final');
    const compareBadge = formEl.querySelector('.product-sale-badge');
    const wrapCount = getPriceContainersForForm(formEl).length;
    if (instance.cfg && instance.cfg.debug) {
      console.log('[CO][price] addonTotal=', addonTotal, 'combinedFinal=', combinedFinal, 'combinedCompare=', combinedCompare);
      console.log('[CO][price] render-targets finalPrice=', !!finalPrice, 'wrapCount=', wrapCount);
      if (!wrapCount) {
        console.warn('[CO][price] no price wrappers found', {
          formId: formEl && formEl.id ? formEl.id : '',
          dataSection: formEl && formEl.getAttribute ? formEl.getAttribute('data-section') : '',
          sectionToken: getSectionTokenFromForm(formEl)
        });
      }
    }

    const format = (cents) =>
      (window.Shopify && window.Shopify.formatMoney) ? window.Shopify.formatMoney(cents) : String(cents);

    instance._coWritingPrice = true;
    try {
      if (finalPrice) {
        if (combinedCompare > combinedFinal) {
          if (comparePrice) {
            comparePrice.textContent = format(combinedCompare);
            comparePrice.removeAttribute('hidden');
          }
          finalPrice.innerHTML = format(combinedFinal);
          finalPrice.classList.add('product-price-final-sale');

          if (compareBadge) {
            compareBadge.removeAttribute('hidden');
            const discountType = compareBadge.dataset.discountType;
            if (discountType === 'percentage') {
              const savingsPct = 100 - Math.round((combinedFinal / combinedCompare) * 100);
              compareBadge.textContent = `${(window.theme && window.theme.locales && window.theme.locales.product && window.theme.locales.product.save) || 'Save'} ${savingsPct}%`;
            } else {
              const savings = format(combinedCompare - combinedFinal);
              compareBadge.textContent = `${(window.theme && window.theme.locales && window.theme.locales.product && window.theme.locales.product.save) || 'Save'} ${savings}`;
            }
          }
        } else {
          if (comparePrice) {
            comparePrice.textContent = '';
            comparePrice.setAttribute('hidden', 'hidden');
          }
          finalPrice.innerHTML = format(combinedFinal);
          finalPrice.classList.remove('product-price-final-sale');
          if (compareBadge) {
            compareBadge.textContent = '';
            compareBadge.setAttribute('hidden', 'hidden');
          }
        }
      } else {
        renderPriceWrapsForForm(formEl, combinedFinal, combinedCompare);
      }

      // Always update theme price wrappers too (some layouts include hidden alt nodes that can absorb selector updates).
      renderPriceWrapsForForm(formEl, combinedFinal, combinedCompare);

      var noteHost = formEl.querySelector('.product-price');
      if (!noteHost) {
        var allPriceWraps = getPriceContainersForForm(formEl);
        var priceWrapForNote = allPriceWraps.length ? allPriceWraps[0] : null;
        noteHost = priceWrapForNote ? (priceWrapForNote.parentElement || formEl) : formEl;
      }

      let note = noteHost.querySelector('.co-bundle-price-note');
      if (!note) {
        note = document.createElement('div');
        note.className = 'co-bundle-price-note small opacity-70 mt-1';
        noteHost.appendChild(note);
      }

      var labels = addons.map(function (a) { return a.label; }).filter(Boolean);
      note.textContent = labels.length ? ('Includes: ' + labels.join(', ')) : 'Includes add-ons';
    } finally {
      if (instance._coWritingPriceTimer) clearTimeout(instance._coWritingPriceTimer);
      instance._coWritingPriceTimer = setTimeout(function () {
        instance._coWritingPrice = false;
      }, 40);
    }
  }

  function buildIndex(cfg) {
    var setsByKey = {};
    var rulesByTrigger = {};

    (cfg.optionSets || []).forEach(function (s) {
      s.key = asString(s.key).trim();
      s.title = asString(s.title).trim();
      s.display_type = asString(s.display_type).trim();

      if (s.values && s.values.length) {
        s.values.forEach(function (v) {
          v.key = asString(v.key).trim();
          v.label = asString(v.label).trim();
          if (!v.key && v.label) v.key = normalizeKey(v.label);

          v.image = asString(v.image).trim();
          var normalizedAddonId = parseVariantId(v.addon_variant_id);
          v.addon_variant_id = normalizedAddonId ? String(normalizedAddonId) : asString(v.addon_variant_id).trim();
          v.addon_variant_price = parseAddonPriceCents(v.addon_variant_price);
          var so = asString(v.sort_order).trim();
          v.sort_order = so === '' ? 999999 : Number(so);
          if (!isFinite(v.sort_order)) v.sort_order = 999999;
        });

        s.values.sort(function (a, b) {
          var av = (a.sort_order === null || a.sort_order === undefined) ? 999999 : a.sort_order;
          var bv = (b.sort_order === null || b.sort_order === undefined) ? 999999 : b.sort_order;
          return av - bv;
        });
      }

      setsByKey[s.key] = s;
    });

    (cfg.rules || []).forEach(function (r) {
      if (!r) return;
      var trig = asString(r.trigger_option_name).trim();
      var valk = asString(r.trigger_value_key).trim();
      if (!trig || !valk) return;

      if (!rulesByTrigger[trig]) rulesByTrigger[trig] = {};
      rulesByTrigger[trig][valk] = safeParseActions(r.actions_text);
    });

    return { setsByKey: setsByKey, rulesByTrigger: rulesByTrigger };
  }

  function matchesOptionFieldName(fieldName, wantedOptionName) {
    var f = String(fieldName || '').trim();
    var w = String(wantedOptionName || '').trim();
    if (!f || !w) return false;

    var fl = f.toLowerCase();
    var wl = w.toLowerCase();
    if (fl === wl) return true; // e.g. "Wood Type"
    if (fl === ('option-' + handleize(w)).toLowerCase()) return true; // e.g. "option-wood-type"

    var m = f.match(/^options\[(.*)\]$/i);
    var bracketInner = m && m[1] ? String(m[1]).trim() : '';
    if (bracketInner && bracketInner.toLowerCase() === wl) return true; // e.g. "options[Wood Type]"

    return false;
  }

  function woodTypeOrderIndex(value) {
    var normalizedValue = normalizeKey(value);
    if (!normalizedValue) return 10000;

    for (var i = 0; i < WOOD_TYPE_DISPLAY_ORDER.length; i++) {
      if (normalizeKey(WOOD_TYPE_DISPLAY_ORDER[i]) === normalizedValue) return i;
    }

    return 10000;
  }

  function reorderWoodTypeRadioGroups(scopeEl) {
    var scope = scopeEl && scopeEl.querySelectorAll ? scopeEl : document;
    var containers = [];

    toArray(scope.querySelectorAll('input[type="radio"]')).forEach(function (radio) {
      if (!matchesOptionFieldName(radio.name, WOOD_TRIGGER)) return;
      var item = radio.closest('.product-single__variant-item');
      if (!item || !item.parentElement) return;
      var container = item.parentElement;
      if (containers.indexOf(container) === -1) containers.push(container);
    });

    containers.forEach(function (container) {
      var items = toArray(container.querySelectorAll('.product-single__variant-item')).filter(function (item) {
        var radio = item.querySelector('input[type="radio"]');
        return !!(radio && matchesOptionFieldName(radio.name, WOOD_TRIGGER));
      });

      if (items.length < 2) return;

      var ordered = items.map(function (item, idx) {
        var radio = item.querySelector('input[type="radio"]');
        return {
          item: item,
          idx: idx,
          order: woodTypeOrderIndex(radio ? radio.value : '')
        };
      });

      ordered.sort(function (a, b) {
        if (a.order !== b.order) return a.order - b.order;
        return a.idx - b.idx;
      });

      var changed = ordered.some(function (entry, idx) {
        return entry.item !== items[idx];
      });
      if (!changed) return;

      var frag = document.createDocumentFragment();
      ordered.forEach(function (entry) {
        frag.appendChild(entry.item);
      });
      container.appendChild(frag);
    });
  }

  function reorderWoodTypeSelects(scopeEl) {
    var scope = scopeEl && scopeEl.querySelectorAll ? scopeEl : document;

    toArray(scope.querySelectorAll('select')).forEach(function (selectEl) {
      if (!matchesOptionFieldName(selectEl.name, WOOD_TRIGGER)) return;

      var options = toArray(selectEl.options || []);
      if (options.length < 2) return;

      var selected = selectEl.value;
      var ordered = options.map(function (optionEl, idx) {
        return {
          optionEl: optionEl,
          idx: idx,
          order: woodTypeOrderIndex(optionEl.value)
        };
      });

      ordered.sort(function (a, b) {
        if (a.order !== b.order) return a.order - b.order;
        return a.idx - b.idx;
      });

      var changed = ordered.some(function (entry, idx) {
        return entry.optionEl !== options[idx];
      });
      if (!changed) return;

      var frag = document.createDocumentFragment();
      ordered.forEach(function (entry) {
        frag.appendChild(entry.optionEl);
      });
      selectEl.appendChild(frag);

      if (selected) selectEl.value = selected;
    });
  }

  function applyWoodTypeDisplayOrder(scopeEl) {
    reorderWoodTypeRadioGroups(scopeEl);
    reorderWoodTypeSelects(scopeEl);
  }

  function applyWoodTypeDefaultSelection(scopeEl) {
    var scope = scopeEl && scopeEl.querySelectorAll ? scopeEl : document;

    toArray(scope.querySelectorAll('product-variant-swatch')).forEach(function (swatchRoot) {
      var woodRadios = toArray(swatchRoot.querySelectorAll('input[type="radio"]')).filter(function (radio) {
        return matchesOptionFieldName(radio.name, WOOD_TRIGGER);
      });
      if (!woodRadios.length) return;

      var currentChecked = woodRadios.find(function (radio) { return !!radio.checked; }) || null;
      var firstEnabled = woodRadios.find(function (radio) {
        return !radio.classList.contains('disabled');
      }) || woodRadios[0];
      if (!firstEnabled) return;
      if (currentChecked === firstEnabled) return;

      woodRadios.forEach(function (radio) { radio.checked = (radio === firstEnabled); });
      firstEnabled.dispatchEvent(new Event('change', { bubbles: true }));
    });

    toArray(scope.querySelectorAll('product-variant-dropdown select')).forEach(function (selectEl) {
      if (!matchesOptionFieldName(selectEl.name, WOOD_TRIGGER)) return;

      var options = toArray(selectEl.options || []);
      if (!options.length) return;

      var firstEnabledOption = options.find(function (opt) { return !opt.disabled; }) || options[0];
      if (!firstEnabledOption) return;
      if (String(selectEl.value) === String(firstEnabledOption.value)) return;

      selectEl.value = firstEnabledOption.value;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function getSelectedShopifyOptionValue(formEl, optionName) {

    var checkedRadio = toArray(formEl.querySelectorAll('input[type="radio"]')).find(function (r) {
      return !!(r && r.checked && matchesOptionFieldName(r.name, optionName));
    });
    if (checkedRadio) return checkedRadio.value;

    var matchingSelect = toArray(formEl.querySelectorAll('select')).find(function (s) {
      return !!(s && matchesOptionFieldName(s.name, optionName));
    });
    if (matchingSelect) return matchingSelect.value;

    return null;
  }

  function getPropertyInput(propsHostEl, propName) {
    var inputName = 'properties[' + propName + ']';
    return propsHostEl.querySelector('input[name="' + inputName.replace(/"/g, '\\"') + '"]');
  }

  function ensurePropertyInput(propsHostEl, propName, setKey) {
    var inputName = 'properties[' + propName + ']';
    var existing = propsHostEl.querySelector('input[name="' + inputName.replace(/"/g, '\\"') + '"]');
    if (existing) {
      // NEW: keep ownership aligned with active set key
      existing.setAttribute('data-custom-prop-for', setKey);
      return existing;
    }

    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = inputName;
    inp.value = '';
    inp.setAttribute('data-custom-prop-for', setKey);
    propsHostEl.appendChild(inp);
    return inp;
  }


  function seatEnabled(instance) {
    var tags = (instance.cfg.productTags || []).map(function (t) { return String(t || '').trim().toLowerCase(); });
    return tags.indexOf(SEAT_TAG) !== -1;
  }

  // ---------- Slot system ----------
  function sortedSetKeysForSlots(instance) {
    var keys = Object.keys(instance.idx.setsByKey || {});
    var priority = function (k) {
      if (String(k || '').indexOf('wood_stain') === 0) return 1000;
      var i = ORDERED_SET_KEYS.indexOf(k);
      return i === -1 ? 999 : i;
    };

    keys.sort(function (a, b) {
      var pa = priority(a), pb = priority(b);
      if (pa !== pb) return pa - pb;
      return a.localeCompare(b);
    });
    return keys;
  }

  function ensureSlots(instance) {
    if (instance.rootEl.dataset.coSlotsReady === '1') return;

    var keys = sortedSetKeysForSlots(instance);

    if (keys.indexOf(FABRIC_SET_KEY) === -1) keys.push(FABRIC_SET_KEY);

    TAGGABLE_SETS.forEach(function (s) {
      if (keys.indexOf(s.key) === -1) keys.push(s.key);
    });

    keys.sort(function (a, b) {
      var pa = (String(a || '').indexOf('wood_stain') === 0) ? 1000 : ORDERED_SET_KEYS.indexOf(a);
      var pb = (String(b || '').indexOf('wood_stain') === 0) ? 1000 : ORDERED_SET_KEYS.indexOf(b);
      pa = (pa === -1) ? 999 : pa;
      pb = (pb === -1) ? 999 : pb;
      if (pa !== pb) return pa - pb;
      return String(a).localeCompare(String(b));
    });

    keys.forEach(function (k) {
      if (instance.rootEl.querySelector('[data-custom-slot="' + k + '"]')) return;
      var slot = document.createElement('div');
      slot.setAttribute('data-custom-slot', k);
      instance.rootEl.appendChild(slot);
    });

    instance.rootEl.dataset.coSlotsReady = '1';
    refreshSlotSpacing(instance);
  }

  function getSlot(instance, setKey) {
    return instance.rootEl.querySelector('[data-custom-slot="' + setKey + '"]');
  }

  function clearSlot(instance, setKey) {
    var slot = getSlot(instance, setKey);
    if (slot) slot.innerHTML = '';
    refreshSlotSpacing(instance);
  }

  function ensureSwatchPreviewModal() {
    var modal = document.getElementById('co-swatch-preview-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'co-swatch-preview-modal';
    modal.className = 'co-swatch-preview';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="co-swatch-preview__backdrop" data-co-swatch-close></div>' +
      '<div class="co-swatch-preview__dialog" role="dialog" aria-modal="true" aria-label="Swatch image preview">' +
        '<button type="button" class="co-swatch-preview__close" aria-label="Close swatch preview" data-co-swatch-close>&times;</button>' +
        '<img class="co-swatch-preview__image" alt="">' +
        '<div class="co-swatch-preview__caption"></div>' +
      '</div>';

    modal.addEventListener('click', function (evt) {
      if (evt.target && evt.target.hasAttribute('data-co-swatch-close')) {
        closeSwatchPreviewModal();
      }
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') closeSwatchPreviewModal();
    });

    document.body.appendChild(modal);
    return modal;
  }

  function openSwatchPreviewModal(imageSrc, label) {
    if (!imageSrc) return;
    var modal = ensureSwatchPreviewModal();
    var imageEl = modal.querySelector('.co-swatch-preview__image');
    var captionEl = modal.querySelector('.co-swatch-preview__caption');
    imageEl.src = imageSrc;
    imageEl.alt = label || 'Swatch preview';
    captionEl.textContent = label || '';
    modal.hidden = false;
    document.body.classList.add('co-swatch-preview-open');
  }

  function closeSwatchPreviewModal() {
    var modal = document.getElementById('co-swatch-preview-modal');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('co-swatch-preview-open');
  }

  function bindSwatchPreviewDelegation() {
    if (document.documentElement.dataset.coSwatchPreviewDelegated === '1') return;
    document.documentElement.dataset.coSwatchPreviewDelegated = '1';

    document.addEventListener('click', function (evt) {
      var target = evt && evt.target ? evt.target : null;
      var trigger = target && target.closest
        ? target.closest('.co-swatch-preview-trigger[data-co-swatch-preview-image]')
        : null;
      if (!trigger) return;

      evt.preventDefault();
      evt.stopPropagation();

      var previewSrc = trigger.getAttribute('data-co-swatch-preview-image');
      var previewLabel = trigger.getAttribute('data-co-swatch-preview-label') || '';
      openSwatchPreviewModal(previewSrc, previewLabel);
    });
  }

  function refreshSlotSpacing(instance) {
    if (!instance || !instance.rootEl) return;

    var slots = toArray(instance.rootEl.querySelectorAll('[data-custom-slot]'));
    var activeSlots = slots.filter(function (slot) {
      return !!slot.querySelector('[data-custom-set]');
    });

    slots.forEach(function (slot) {
      slot.classList.remove('co-slot-active');
      slot.classList.remove('mb-25');
    });

    activeSlots.forEach(function (slot, idx) {
      slot.classList.add('co-slot-active');
      if (idx < activeSlots.length - 1) slot.classList.add('mb-25');
    });

    if (activeSlots.length > 0) instance.rootEl.classList.add('mb-20');
    else instance.rootEl.classList.remove('mb-20');
  }

  function clearPropertyBySetKey(propsHostEl, setKey) {
    var el = propsHostEl.querySelector('input[data-custom-prop-for="' + setKey + '"]');
    if (el) {
      el.value = '';
      clearAddonMetaOnPropertyInput(el);
    }
  }

  function clearAddonMetaOnPropertyInput(inputEl) {
    if (!inputEl || !inputEl.dataset) return;
    delete inputEl.dataset.addonVariantId;
    delete inputEl.dataset.addonVariantPrice;
  }

  function setAddonMetaOnPropertyInput(inputEl, selectedValue) {
    if (!inputEl) return;
    clearAddonMetaOnPropertyInput(inputEl);
    if (!selectedValue) return;

    var addonId = parseVariantId(selectedValue.addon_variant_id);
    if (addonId) inputEl.dataset.addonVariantId = String(addonId);

    var addonPrice = parseAddonPriceCents(selectedValue.addon_variant_price);
    if (addonPrice > 0) inputEl.dataset.addonVariantPrice = String(addonPrice);
  }

  function looksLikeCssColor(value) {
    var s = String(value || '').trim();
    if (!s) return false;
    var el = document.createElement('span');
    el.style.color = '';
    el.style.color = s;
    return !!el.style.color;
  }

  // ---------- Rendering ----------
  function restoreSelectedValue(instance, propName, values) {
    var inp = getPropertyInput(instance.propsHostEl, propName);
    if (!inp || !inp.value) return null;
    var label = inp.value;
    return values.find(function (v) { return v.label === label; }) || null;
  }

  function renderOptionSet(instance, setObj, allowedKeys, required, opts) {
    opts = opts || {};
    ensureSlots(instance);

    var setKey = asString(setObj.key).trim();
    var title = asString(setObj.title || setKey).trim();
    var displayType = String(setObj.display_type || 'list').toLowerCase();

    if (setKey === FABRIC_SET_KEY) displayType = 'list';

    var isRadio = (displayType === 'radio' || displayType === 'buttons' || displayType === 'button');

    var slot = getSlot(instance, setKey);
    if (!slot) return;

    if (!opts.forceRerender && slot.querySelector('[data-custom-set="' + setKey + '"]')) return;

    var propName = getPropertyNameForSet(setKey, title);

    var existingProp = getPropertyInput(instance.propsHostEl, propName);
    var existingVal = existingProp ? existingProp.value : '';

    slot.innerHTML = '';

    var values = (setObj.values || []).slice().map(function (v) {
      var addonPrice = parseAddonPriceCents(v ? v.addon_variant_price : 0);
      var addonId = parseVariantId(v ? v.addon_variant_id : '');
      var addonIdRaw = asString(v && v.addon_variant_id).trim();

      return {
        label: asString(v.label).trim(),
        key: asString(v.key).trim(),
        image: asString(v.image).trim(),
        image_large: asString(v.image_large || v.image).trim(),
        sort_order: (v.sort_order === null || v.sort_order === undefined) ? 999999 : Number(v.sort_order),
        addon_variant_id: addonId ? String(addonId) : addonIdRaw,
        addon_variant_price: addonPrice
      };
    });

    if (allowedKeys && allowedKeys.length) {
      var allowedSet = {};
      allowedKeys.forEach(function (k) {
        var kk = asString(k).trim();
        if (kk) allowedSet[kk] = true;
      });

      var filtered = values.filter(function (v) { return !!allowedSet[v.key]; });
      if (!filtered.length) filtered = values.filter(function (v) { return !!allowedSet[v.label]; });

      if (instance.cfg && instance.cfg.debug) {
        console.log('[CO] set', setKey, 'allowed', allowedKeys.length, 'total', values.length, 'filtered', filtered.length);
      }

      values = filtered;
    }

    if (!values.length) {
      refreshSlotSpacing(instance);
      return;
    }

    var wrap = document.createElement('div');
    wrap.className = 'co-option-set';
    if (isRadio) wrap.classList.add('co-option-set-radio');
    else if (displayType === 'swatch') wrap.classList.add('co-option-set-swatch');
    else wrap.classList.add('co-option-set-select');
    wrap.setAttribute('data-custom-set', setKey);

    instance.required[setKey] = !!required;

    var propInput = ensurePropertyInput(instance.propsHostEl, propName, setKey);
    if (!propInput.value && existingVal) propInput.value = existingVal;

    var restored = restoreSelectedValue(instance, propName, values);
    var initialSelected = restored || null;

    // Default radio-style sets to the first option when no valid selection exists.
    if (!initialSelected && isRadio && values.length) {
      initialSelected = values[0];
      propInput.value = initialSelected.label;
    }

    if (initialSelected) {
      instance.selectedCustom[setKey] = initialSelected;
      setAddonMetaOnPropertyInput(propInput, initialSelected);
    } else {
      instance.selectedCustom[setKey] = null;
      clearAddonMetaOnPropertyInput(propInput);
    }

    var header = document.createElement('div');
    header.className = 'product-single__control-label mb-15';

    var headerText = title;
    if (String(setKey).indexOf('wood_stain') === 0) {
      var woodLabel = getWoodLabelForStainSetKey(setKey);
      if (woodLabel) headerText = 'Wood Stain: ' + woodLabel;
    }

    var currentValueEl = null;
    if (isRadio || displayType === 'swatch') {
      header.textContent = headerText + ': ';
      currentValueEl = document.createElement('span');
      currentValueEl.className = 'variant_current';
      currentValueEl.textContent = propInput.value || '';
      header.appendChild(currentValueEl);
    } else {
      header.textContent = headerText;
      wrap.appendChild(header);
    }

    if (displayType === 'swatch') {
      var isWoodStainSet = String(setKey).indexOf('wood_stain') === 0;
      var swatchFieldset = document.createElement('fieldset');
      swatchFieldset.className = 'product-variant-form-input variant-color co-swatch-fieldset';
      swatchFieldset.appendChild(header);

      var swatchList = document.createElement('div');
      swatchList.className = 'block-content d-flex flex-wrap';
      var swatchName = 'co-' + setKey + '-' + (instance.cfg.productId || 'p');

      values.forEach(function (v) {
        var item = document.createElement('div');
        item.className = 'product-single__variant-item mb-10 co-swatch-wrap';
        item.setAttribute('data-tooltip', v.label);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = swatchName;
        input.id = swatchName + '-' + handleize(v.label);
        input.value = v.label;
        if (v.addon_variant_id) input.dataset.addonVariantId = String(v.addon_variant_id);
        if (v.addon_variant_price) input.dataset.addonVariantPrice = String(v.addon_variant_price);
        if (propInput.value && propInput.value === v.label) input.checked = true;

        var label = document.createElement('label');
        label.setAttribute('for', input.id);

        var colorClass = 'variant-color-' + handleize(v.label);
        var hasImage = !!v.image;
        var isCssColor = looksLikeCssColor(v.label);

        if (hasImage) {
          label.className = colorClass + ' img co-swatch-visual';
          label.setAttribute('data-swatch-label', v.label);

          var img = document.createElement('img');
          img.src = v.image;
          img.alt = v.label;
          img.loading = 'lazy';
          label.appendChild(img);

          if (isWoodStainSet && v.image_large) {
            item.classList.add('co-swatch-wrap--previewable');

            var previewButton = document.createElement('button');
            previewButton.type = 'button';
            previewButton.className = 'co-swatch-preview-trigger';
            previewButton.setAttribute('aria-label', 'View larger swatch image for ' + v.label);
            previewButton.innerHTML =
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                '<path d="M10 4a6 6 0 1 0 3.874 10.582l4.772 4.772 1.414-1.414-4.772-4.772A6 6 0 0 0 10 4zm0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"></path>' +
              '</svg>';
            previewButton.addEventListener('click', function (evt) {
              evt.preventDefault();
              evt.stopPropagation();
              openSwatchPreviewModal(v.image_large, v.label);
            });
            item.appendChild(previewButton);
          }
        } else if (isCssColor) {
          label.className = colorClass + ' color co-swatch-visual';
          label.setAttribute('data-swatch-label', v.label);
          label.style.backgroundColor = v.label;
          label.setAttribute('aria-label', v.label);
        } else {
          label.className = 'co-swatch-text';
          label.textContent = v.label;
        }

        input.addEventListener('change', function () {
          var chosen = values.find(function (x) { return x.label === input.value; }) || null;
          propInput.value = chosen ? chosen.label : '';
          instance.selectedCustom[setKey] = chosen;
          setAddonMetaOnPropertyInput(propInput, chosen);
          if (currentValueEl) currentValueEl.textContent = chosen ? chosen.label : '';

          if (setKey === SEAT_SET_KEY) {
            applyDependents(instance);
          } else {
            scheduleBundledPrice(instance);
          }

          if (setKey === CARVING_STYLE_KEY) {
            applyCarvingRules(instance);
          }
        });

        item.appendChild(input);
        item.appendChild(label);
        swatchList.appendChild(item);
      });

      swatchFieldset.appendChild(swatchList);
      wrap.appendChild(swatchFieldset);

      if (isWoodStainSet) {
        var requestWrap = document.createElement('div');
        requestWrap.className = 'co-wood-swatch-request';

        var requestLink = document.createElement('a');
        requestLink.className = 'product-single__share-ask-sizeguide-title co-wood-swatch-request-link';
        requestLink.setAttribute('aria-label', 'Request wood swatches');
        requestLink.href = '/pages/request-samples';
        requestLink.target = '_blank';
        requestLink.rel = 'noopener noreferrer';
        requestLink.innerHTML =
          '<i class="zmdi zmdi-email align-middle" aria-hidden="true"></i>' +
          '<span class="f_pr align-middle">Request Wood Swatches</span>';

        requestWrap.appendChild(requestLink);
        wrap.appendChild(requestWrap);
      }
    } else if (isRadio) {
      var fieldset = document.createElement('fieldset');
      fieldset.className = 'product-variant-form-input co-radio-fieldset';
      fieldset.appendChild(header);

      var list = document.createElement('div');
      list.className = 'block-content d-flex flex-wrap size-buttons';

      var name = 'co-' + setKey + '-' + (instance.cfg.productId || 'p');

      values.forEach(function (v) {
        var li = document.createElement('div');
        li.className = 'product-single__variant-item mb-10';

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = name;
        input.id = name + '-' + handleize(v.label);
        input.value = v.label;
        if (v.addon_variant_id) input.dataset.addonVariantId = String(v.addon_variant_id);
        if (v.addon_variant_price) input.dataset.addonVariantPrice = String(v.addon_variant_price);

        if (propInput.value && propInput.value === v.label) input.checked = true;

        var lbl = document.createElement('label');
        lbl.setAttribute('for', input.id);
        lbl.textContent = v.label;

        input.addEventListener('change', function () {
          var chosen = values.find(function (x) { return x.label === input.value; }) || null;
          propInput.value = chosen ? chosen.label : '';
          instance.selectedCustom[setKey] = chosen;
          setAddonMetaOnPropertyInput(propInput, chosen);
          if (currentValueEl) currentValueEl.textContent = chosen ? chosen.label : '';

          if (setKey === SEAT_SET_KEY) {
            applyDependents(instance);
          } else {
            scheduleBundledPrice(instance);
          }

          if (setKey === CARVING_STYLE_KEY) {
            applyCarvingRules(instance);
          }
        });

        li.appendChild(input);
        li.appendChild(lbl);
        list.appendChild(li);
      });

      fieldset.appendChild(list);
      wrap.appendChild(fieldset);
    } else {
      var select = document.createElement('select');
      select.className = 'form-select';

      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Select…';
      select.appendChild(ph);

      values.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.key;
        opt.textContent = v.label;
        if (v.addon_variant_id) opt.dataset.addonVariantId = String(v.addon_variant_id);
        if (v.addon_variant_price) opt.dataset.addonVariantPrice = String(v.addon_variant_price);
        select.appendChild(opt);
      });

      if (instance.selectedCustom[setKey] && instance.selectedCustom[setKey].key) {
        select.value = instance.selectedCustom[setKey].key;
      } else if (propInput.value) {
        var fromLabel = values.find(function (vv) { return vv.label === propInput.value; });
        if (fromLabel) select.value = fromLabel.key;
      }

      select.addEventListener('change', function () {
        var chosenKey = select.value;
        var chosen = values.find(function (vv) { return vv.key === chosenKey; }) || null;

        propInput.value = chosen ? chosen.label : '';
        instance.selectedCustom[setKey] = chosen;
        setAddonMetaOnPropertyInput(propInput, chosen);

        if (setKey === SEAT_SET_KEY) {
          applyDependents(instance);
        } else {
          scheduleBundledPrice(instance);
        }

        if (setKey === CARVING_STYLE_KEY) {
          applyCarvingRules(instance);
        }
      });

      wrap.appendChild(select);
    }

    if (setKey === FABRIC_SET_KEY) {
      var linkWrap = document.createElement('div');
      linkWrap.className = 'mt-2';

      var a = document.createElement('a');
      a.href = 'https://heartland-fabrics.com';
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.textContent = 'View Fabric Options >';
      a.className = 'text-decoration-underline';
      a.style.fontSize = '14px';
      a.style.display = 'inline-block';

      linkWrap.appendChild(a);
      wrap.appendChild(linkWrap);
    }

    slot.appendChild(wrap);
    refreshSlotSpacing(instance);
  }

  // ---------- Rules ----------
  function evaluateActions(instance, triggerName, triggerValueKey) {
    var idx = instance.idx;
    var actions = ((idx.rulesByTrigger[triggerName] || {})[triggerValueKey]) || [];

    var plan = {};
    actions.forEach(function (a) {
      if (!a || !a.type || !a.option_set_key) return;

      var setKey = asString(a.option_set_key).trim();
      if (setKey.indexOf('-') !== -1) setKey = setKey.replace(/-/g, '_');

      if (!plan[setKey]) plan[setKey] = { allowed: null, required: false, fabric_list_key: null };

      if (a.type === 'show') {
        plan[setKey].allowed = a.allowed_value_keys || null;
        if (a.fabric_list_key) plan[setKey].fabric_list_key = asString(a.fabric_list_key).trim();
      }
      if (a.type === 'require') plan[setKey].required = true;
    });

    return plan;
  }

  function applyWood(instance) {
    var woodKeys = [];

    // co:no_stains => never show any wood stain UI for this product
    if (hasTag(instance, NO_STAINS_TAG)) {
      clearAllWoodStains(instance);
      return;
    }


    if (hasShopifyOption(instance, WOOD_TRIGGER)) {
      var woodVal = getSelectedShopifyOptionValue(instance.formEl, WOOD_TRIGGER);
      if (!woodVal) {
        Object.keys(instance.idx.setsByKey || {}).forEach(function (k) {
          if (k.indexOf('wood_stain') === 0) {
            clearSlot(instance, k);
            clearPropertyBySetKey(instance.propsHostEl, k);
            instance.selectedCustom[k] = null;
            instance.required[k] = false;
          }
        });
        instance._lastWoodKeysSig = '';
        return;
      }
      woodKeys = [normalizeKey(woodVal)];
    } else {
      woodKeys = getStainKeysFromTags(instance);
      if (!woodKeys.length) {
        Object.keys(instance.idx.setsByKey || {}).forEach(function (k) {
          if (k.indexOf('wood_stain') === 0) {
            clearSlot(instance, k);
            clearPropertyBySetKey(instance.propsHostEl, k);
            instance.selectedCustom[k] = null;
            instance.required[k] = false;
          }
        });
        instance._lastWoodKeysSig = '';
        return;
      }
    }

    var woodKeysSig = woodKeys.slice().sort().join('|');
    if (instance._lastWoodKeysSig !== woodKeysSig) {
      Object.keys(instance.idx.setsByKey || {}).forEach(function (k) {
        if (k.indexOf('wood_stain') === 0) {
          clearSlot(instance, k);
          clearPropertyBySetKey(instance.propsHostEl, k);
          instance.selectedCustom[k] = null;
          instance.required[k] = false;
        }
      });
      instance._lastWoodKeysSig = woodKeysSig;
    }

    var combinedPlan = {};
    woodKeys.forEach(function (wk) {
      var p = evaluateActions(instance, WOOD_TRIGGER, wk);
      Object.keys(p || {}).forEach(function (setKey) {
        combinedPlan[setKey] = p[setKey];
      });
    });

    // ----- Paint Colors (wood-driven) -----
    var nextPaintKeyToShow = null;

    if (hasTag(instance, PAINT_COLORS_TAG)) {
      if (combinedPlan[PAINT_COLORS_OAK_KEY]) nextPaintKeyToShow = PAINT_COLORS_OAK_KEY;
      else if (combinedPlan[PAINT_COLORS_BROWN_MAPLE_KEY]) nextPaintKeyToShow = PAINT_COLORS_BROWN_MAPLE_KEY;
    }

    // Only clear/re-render if the paint set actually changed
    if (nextPaintKeyToShow !== instance._lastPaintKeyToShow) {
      clearPaintColorVariants(instance);

      if (nextPaintKeyToShow) {
        var paintSet = instance.idx.setsByKey[nextPaintKeyToShow];
        if (paintSet) {
          renderOptionSet(
            instance,
            paintSet,
            combinedPlan[nextPaintKeyToShow] ? combinedPlan[nextPaintKeyToShow].allowed : null,
            combinedPlan[nextPaintKeyToShow] ? combinedPlan[nextPaintKeyToShow].required : false,
            { forceRerender: true }
          );
        }
      }

      instance._lastPaintKeyToShow = nextPaintKeyToShow;
    }




    if (!combinedPlan || !Object.keys(combinedPlan).length) {
      Object.keys(instance.idx.setsByKey || {}).forEach(function (k) {
        if (k.indexOf('wood_stain') === 0) {
          clearSlot(instance, k);
          clearPropertyBySetKey(instance.propsHostEl, k);
          instance.selectedCustom[k] = null;
          instance.required[k] = false;
        }
      });
      return;
    }

    var isBainbridge = hasTag(instance, BAINBRIDGE_TAG);

    Object.keys(combinedPlan).forEach(function (setKey) {
      if (setKey.indexOf('wood_stain') !== 0) return;

      var effectiveKey = setKey;

      // If bainbridge tagged, prefer wood_stain_<wood>_bainbridge if it exists
      if (isBainbridge) {
        var bbKey = bainbridgeKeyFor(setKey);
        if (instance.idx.setsByKey[bbKey]) {
          effectiveKey = bbKey;
        }
      }

      var setObj = instance.idx.setsByKey[effectiveKey];
      if (!setObj) return;

      renderOptionSet(
        instance,
        setObj,
        combinedPlan[setKey].allowed,      // keep same allowed/required from the rule plan
        combinedPlan[setKey].required,
        { forceRerender: true }
      );
  });

  }

  function applySeatBase(instance) {
    if (!seatEnabled(instance)) {
      clearSlot(instance, SEAT_SET_KEY);
      clearSlot(instance, FABRIC_SET_KEY);
      instance.required[SEAT_SET_KEY] = false;
      instance.required[FABRIC_SET_KEY] = false;
      return;
    }

    var seatSet = instance.idx.setsByKey[SEAT_SET_KEY];
    if (!seatSet) return;

    renderOptionSet(instance, seatSet, null, true, { forceRerender: false });
  }

  function applyTaggableBases(instance) {
    TAGGABLE_SETS.forEach(function (def) {
      // Skip dynamic sets (they are rendered by other logic)
      if (def.dynamic) return;

      var enabled = hasTag(instance, def.tag);
      if (!enabled) {
        clearSlot(instance, def.key);
        clearPropertyBySetKey(instance.propsHostEl, def.key);
        instance.selectedCustom[def.key] = null;
        instance.required[def.key] = false;
        return;
      }

      if (def.file_list_key) {
        renderFileBackedTaggableSet(instance, def);
        return;
      }

      var setObj = instance.idx.setsByKey[def.key];
      if (!setObj) return;

      renderOptionSet(instance, setObj, null, !!def.required, { forceRerender: false });
    });
  }


  async function applyDependents(instance, opts) {
    opts = opts || {};
    var dependentsSeq = (instance._coDependentsSeq || 0) + 1;
    instance._coDependentsSeq = dependentsSeq;
    var idx = instance.idx;
    ensureSlots(instance);

    if (!seatEnabled(instance)) {
      clearSlot(instance, SEAT_SET_KEY);
      instance.required[SEAT_SET_KEY] = false;
    }

    var seatSelected = instance.selectedCustom[SEAT_SET_KEY];
    var seatKey = '';

    if (seatSelected) {
      seatKey = asString(seatSelected.key).trim();
      if (!seatKey) seatKey = normalizeKey(asString(seatSelected.label).trim());
    }

    var cushionVal = getSelectedShopifyOptionValue(instance.formEl, CUSHION_TRIGGER);
    var cushionKey = cushionVal ? normalizeKey(cushionVal) : '';

    var seatPlan = seatKey ? evaluateActions(instance, SEAT_TRIGGER, seatKey) : {};
    var cushionPlan = cushionKey ? evaluateActions(instance, CUSHION_TRIGGER, cushionKey) : {};

    var mergedPlan = {};
    function mergePlan(p) {
      Object.keys(p || {}).forEach(function (k) { mergedPlan[k] = p[k]; });
    }
    mergePlan(seatPlan);
    mergePlan(cushionPlan);

    if (!mergedPlan[FABRIC_SET_KEY]) {
      clearSlot(instance, FABRIC_SET_KEY);
      clearPropertyBySetKey(instance.propsHostEl, FABRIC_SET_KEY);
      instance.selectedCustom[FABRIC_SET_KEY] = null;
      instance.required[FABRIC_SET_KEY] = false;
    }

    Object.keys(mergedPlan).forEach(function (setKey) {
      if (setKey === FABRIC_SET_KEY) return;

      var setObj = idx.setsByKey[setKey];
      if (!setObj) return;
      renderOptionSet(instance, setObj, mergedPlan[setKey].allowed, mergedPlan[setKey].required, { forceRerender: true });
    });

    if (mergedPlan[FABRIC_SET_KEY]) {
      clearSlot(instance, FABRIC_SET_KEY);

      var fabricsData = await loadFabricLists();
      if (instance._coDependentsSeq !== dependentsSeq) return;

      var listKey = mergedPlan[FABRIC_SET_KEY].fabric_list_key
        ? asString(mergedPlan[FABRIC_SET_KEY].fabric_list_key).trim()
        : '';

      if (!listKey) {
        var ak = mergedPlan[FABRIC_SET_KEY].allowed || [];
        if (ak && ak.length) listKey = asString(ak[0]).trim();
      }

      var list = (fabricsData && listKey && Array.isArray(fabricsData[listKey]))
        ? fabricsData[listKey]
        : [];

      if (list.length) {
        var virtualFabricSet = buildTextSet(
          FABRIC_SET_KEY,
          'Fabric Selection',
          list,
          'list'
        );

        renderOptionSet(
          instance,
          virtualFabricSet,
          null,
          mergedPlan[FABRIC_SET_KEY].required,
          { forceRerender: true }
        );

        instance.required[FABRIC_SET_KEY] = true;
      } else {
        clearSlot(instance, FABRIC_SET_KEY);
        clearPropertyBySetKey(instance.propsHostEl, FABRIC_SET_KEY);
        instance.selectedCustom[FABRIC_SET_KEY] = null;
        instance.required[FABRIC_SET_KEY] = false;
      }
    }

    if (instance._coDependentsSeq !== dependentsSeq) return;
    instance._lastSeatKey = seatKey;

    // dependents can change addons too
    if (!opts.skipPriceSchedule) scheduleBundledPrice(instance);
  }

  // ---------- Validation + Add to cart bundle ----------
  function validate(instance) {
    var missing = [];

    Object.keys(instance.required || {}).forEach(function (setKey) {
      if (!instance.required[setKey]) return;

      var setObj = instance.idx.setsByKey[setKey]
        || (setKey === FABRIC_SET_KEY ? { key: FABRIC_SET_KEY, title: 'Fabric Selection' } : null)
        || (setKey === EARLY_AMERICAN_FABRIC_SET_KEY ? { key: EARLY_AMERICAN_FABRIC_SET_KEY, title: 'Early American Fabric Selection' } : null);
      if (!setObj) return;

      var baseTitle = setObj.title || setKey;
      var propName = getPropertyNameForSet(setKey, baseTitle);

      var inputName = 'properties[' + propName + ']';
      var input = instance.formEl.querySelector('input[name="' + inputName.replace(/"/g, '\\"') + '"]');
      if (!input || !input.value) missing.push(propName);
    });

    if (missing.length) {
      alert('Please select: ' + missing.join(', '));
      return false;
    }
    return true;
  }

  //  FIX: use /cart/add.js with {items} only (most compatible)
  //  FIX: validate addon ids + require addon variant to be available (otherwise Shopify rejects the whole add)
  async function addBundleToCart(instance, triggerBtn) {
    setAddToCartButtonBusy(triggerBtn, true);

    try {
      var baseRaw = instance.formEl.querySelector('[name="id"]')?.value;
      var baseId = parseVariantId(baseRaw);
      if (!baseId) {
        showAddToCartError(instance, 'Missing base variant ID.');
        return;
      }

      var qty = Number(instance.formEl.querySelector('input[name="quantity"]')?.value || 1);
      if (!qty || qty < 1) qty = 1;

      var props = {};
      toArray(instance.formEl.querySelectorAll('input[name^="properties["]')).forEach(function (inp) {
        var m = inp.name.match(/^properties\[(.*)\]$/);
        if (!m) return;
        if (inp.value) props[m[1]] = inp.value;
      });

      var bundleKey = 'co_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      props['_co_bundle'] = bundleKey;

      var addons = getAddonSelections(instance);

      for (var i = 0; i < addons.length; i++) {
        var addId = parseVariantId(addons[i].addon_variant_id);
        if (!addId) {
          showAddToCartError(instance, 'An add-on selection has an invalid variant ID.');
          return;
        }
        var v = await getVariantData(addId);
        if (!v) {
          showAddToCartError(instance, 'Add-on variant could not be loaded: ' + addId);
          return;
        }
        if (!v.available) {
          showAddToCartError(instance, 'Selected add-on is unavailable: ' + (addons[i].label || 'Add-on'));
          return;
        }
      }

      if (addons.length) props['_co_addon_variant_ids'] = addons.map(function (a) { return a.addon_variant_id; }).join(',');
      else delete props['_co_addon_variant_ids'];

      var items = [{ id: Number(baseId), quantity: qty, properties: props }];

      addons.forEach(function (a) {
        var idNum = parseVariantId(a.addon_variant_id);
        if (!idNum) return;
        items.push({
          id: Number(idNum),
          quantity: qty,
          properties: { '_co_bundle': bundleKey, '_co_addon_for': a.label || a.setKey }
        });
      });

      var payload = { items: items };
      var data = null;
      var requestOk = false;

      if (window.jQuery && typeof window.jQuery.ajax === 'function') {
        try {
          data = await new Promise(function (resolve, reject) {
            window.jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: JSON.stringify(payload),
              contentType: 'application/json; charset=utf-8',
              dataType: 'json',
              success: function (responseData) {
                resolve(responseData || null);
              },
              error: function (xhr) {
                var responseData = null;
                try {
                  responseData = xhr && xhr.responseText ? JSON.parse(xhr.responseText) : null;
                } catch (_parseError) {
                  responseData = null;
                }
                reject({ data: responseData });
              }
            });
          });
          requestOk = true;
        } catch (jqErr) {
          data = jqErr && jqErr.data ? jqErr.data : null;
          requestOk = false;
        }
      } else {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });

        data = await res.json().catch(function () { return null; });
        requestOk = !!res.ok;
      }

      if (!requestOk) {
        var msg = (data && (data.description || data.message)) ? (data.description || data.message) : 'Could not add to cart';
        showAddToCartError(instance, msg);
        return;
      }

      await refreshCartUI();

      window.dispatchEvent(new CustomEvent('co.cart.added', { detail: data }));
      window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }));

      var cartMode = window.theme && window.theme.cart_status ? String(window.theme.cart_status) : '';
      if (cartMode === 'goto_page_cart') {
        window.location.href = '/cart';
        return;
      }

      openMiniCartDrawer();
    } finally {
      setAddToCartButtonBusy(triggerBtn, false);
    }
  }

  function initProductForm(productFormEl) {
    var formEl = (productFormEl && productFormEl.matches && productFormEl.matches('form'))
      ? productFormEl
      : (productFormEl ? productFormEl.querySelector('form') : null);

    var scopeEl = formEl || productFormEl;
    var rootEl = scopeEl ? scopeEl.querySelector('[data-custom-options-root]') : null;
    var propsHostEl = scopeEl ? scopeEl.querySelector('[data-custom-options-properties]') : null;
    var cfgEl = scopeEl ? scopeEl.querySelector('[data-custom-options-config]') : null;

    if (!rootEl || !propsHostEl || !cfgEl || !formEl) return;
    if (rootEl.dataset.customOptionsInit === '1') return;
    rootEl.dataset.customOptionsInit = '1';
    rootEl.classList.add('product-options');

    var cfg = parseJSONFromScript(cfgEl);
    if (!cfg || !cfg.productId) return;
    if (!formEl.dataset.variants && Array.isArray(cfg.variants) && cfg.variants.length) {
      try {
        formEl.dataset.variants = JSON.stringify(cfg.variants);
      } catch (e) {}
    }

    var instance = {
      productFormEl: scopeEl,
      formEl: formEl,
      rootEl: rootEl,
      propsHostEl: propsHostEl,
      cfg: cfg,
      idx: buildIndex(cfg),
      required: {},
      selectedCustom: {},
      _lastWoodKeysSig: '',
      _lastSeatKey: null,
      _selectedVariant: getCurrentVariantFromForm(formEl) || cfg.selectedVariant || null,
      _coPriceTimer: null,
      _lastPaintKeyToShow: null,
      _coDependentsSeq: 0,
      _onVariantChange: null
    };

    ensureSlots(instance);
    bindPriceObserver(instance);

    applyWood(instance);
    applySeatBase(instance);
    applyTaggableBases(instance);
    Promise.resolve(applyDependents(instance, { skipPriceSchedule: true })).finally(function () {
      scheduleBundledPrice(instance);
    });
    applyCarvingRules(instance);

    instance._onVariantChange = function (e) {
      if (!document.body.contains(instance.formEl)) {
        window.removeEventListener('kt.product.variant.change', instance._onVariantChange);
        return;
      }

      var eventVariant = (e && e.detail && e.detail.variant)
        ? e.detail.variant
        : (e && e.detail ? e.detail : null);
      var liveVariant = getCurrentVariantFromForm(instance.formEl);
      instance._selectedVariant = eventVariant || liveVariant || instance._selectedVariant || (instance.cfg ? instance.cfg.selectedVariant : null);

      applyWood(instance);
      applySeatBase(instance);
      applyTaggableBases(instance);
      Promise.resolve(applyDependents(instance, { skipPriceSchedule: true })).finally(function () {
        scheduleBundledPriceAfterTheme(instance);
      });
      applyCarvingRules(instance);
    };
    window.addEventListener('kt.product.variant.change', instance._onVariantChange);

    formEl.addEventListener('change', function (e) {
      var t = e && e.target ? e.target : null;
      var isCustomOptionChange = !!(t && t.closest && t.closest('[data-custom-set]'));
      var woodChanged = !!(t && matchesOptionFieldName(t.name, WOOD_TRIGGER));

      if (isCustomOptionChange) return;

      var changedVariant = getCurrentVariantFromForm(instance.formEl);
      if (changedVariant) instance._selectedVariant = changedVariant;

      if (woodChanged) applyWood(instance);
      applySeatBase(instance);
      applyTaggableBases(instance);
      Promise.resolve(applyDependents(instance, { skipPriceSchedule: true })).finally(function () {
        scheduleBundledPriceAfterTheme(instance);
      });
      applyCarvingRules(instance);
    });

    formEl.addEventListener('click', async function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var btn = target.closest('[name="add"], .product-form__cart-submit');
      if (!btn || !formEl.contains(btn)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!validate(instance)) return false;
      await addBundleToCart(instance, btn);
      return false;
    }, true);

    formEl.addEventListener('submit', async function (e) {
      if (!validate(instance)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      var submitBtn = formEl.querySelector('[name="add"], .product-form__cart-submit');
      await addBundleToCart(instance, submitBtn);
      return false;
    }, true);
  }

  function boot() {
    bindSwatchPreviewDelegation();
    applyWoodTypeDisplayOrder(document);
    applyWoodTypeDefaultSelection(document);

    toArray(document.querySelectorAll('[data-custom-options-root]')).forEach(function (root) {
      var formEl = root.closest('form');
      if (formEl) initProductForm(formEl);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();



